const _global = typeof window === "undefined" ? (typeof global === "undefined" ? {} : global) : window;
const document = _global.document;

let lastestTouchPoint = "";

export function registeredGlobalClickEventForGettingTouchPoint(e) {
  const x = e.clientX || e.x || e.offsetX || e.pageX || "";
  const y = e.clientY || e.y || e.offsetY || e.pageY || "";
  lastestTouchPoint = `${x},${y}`;
}

if (document && document.addEventListener) {
  document.addEventListener("click", registeredGlobalClickEventForGettingTouchPoint, true);
}

function _getPluginsSafely(plugins) {
  try {
    return [].slice
      .call(plugins || [], 0)
      .map(function(plugin) {
        return plugin && plugin.name;
      })
      .filter(Boolean);
  } catch (e) {
    return [];
  }
}

export function getRiskParams() {
  // https://wiki.sankuai.com/pages/viewpage.action?pageId=607626501
  const navigator = _global.navigator || {};
  const screen = _global.screen || {};
  const documentElement = document.documentElement || document.body || {};
  return {
    ua: navigator.userAgent,
    touchPoint: lastestTouchPoint,
    browserPlugins: _getPluginsSafely(navigator.plugins).join(","),
    colorDepth: screen.colorDepth,
    pixelDepth: screen.pixelDepth,
    screenWith: screen.width,
    screenHeight: screen.height,
    browserPageWidth: documentElement.offsetWidth,
    browserPageHeight: documentElement.offsetHeight,
  };
}
